/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React from 'react'

import { BaseIcon, IconVariantComponent } from './BaseIcon'
import { BRONTE_ICONS_NAMES } from './bronte-icons/constants'

type NamesType = typeof BRONTE_ICONS_NAMES
type NamesKeys = keyof NamesType
export type IconNames = NamesType[NamesKeys]

export type IconComponent = IconVariantComponent & {
  Add: IconVariantComponent
  Afterpay: IconVariantComponent
  ArrowDown: IconVariantComponent
  ArrowLeft: IconVariantComponent
  ArrowRight: IconVariantComponent
  ArrowUp: IconVariantComponent
  Attachment: IconVariantComponent
  Bank: IconVariantComponent
  BankStatement: IconVariantComponent
  Barcode: IconVariantComponent
  BasketUpdate: IconVariantComponent
  Box: IconVariantComponent
  BoxArrowDown: IconVariantComponent
  Bpay: IconVariantComponent
  Browser: IconVariantComponent
  Bulb: IconVariantComponent
  Calendar: IconVariantComponent
  CalendarDate: IconVariantComponent
  Camera: IconVariantComponent
  Car: IconVariantComponent
  Card: IconVariantComponent
  CardUpdate: IconVariantComponent
  CaretDown: IconVariantComponent
  CaretLeft: IconVariantComponent
  CaretRight: IconVariantComponent
  CaretUp: IconVariantComponent
  Chat: IconVariantComponent
  Chatting: IconVariantComponent
  Check: IconVariantComponent
  CheckIn: IconVariantComponent
  CheckOut: IconVariantComponent
  Cheque: IconVariantComponent
  Close: IconVariantComponent
  CloseCircle: IconVariantComponent
  Coins: IconVariantComponent
  Copy: IconVariantComponent
  CurrencyExchange: IconVariantComponent
  Discount2: IconVariantComponent
  Dollar: IconVariantComponent
  Download: IconVariantComponent
  DownloadAlt: IconVariantComponent
  Edit: IconVariantComponent
  Email: IconVariantComponent
  Exit: IconVariantComponent
  External: IconVariantComponent
  Filter: IconVariantComponent
  Gift: IconVariantComponent
  Globe: IconVariantComponent
  Grid: IconVariantComponent
  Guard: IconVariantComponent // manually added
  Handout: IconVariantComponent
  Heart: IconVariantComponent
  Heartbeat: IconVariantComponent
  History: IconVariantComponent
  Home: IconVariantComponent
  Image: IconVariantComponent
  Info: IconVariantComponent
  Lightning: IconVariantComponent
  Link: IconVariantComponent
  Loan: IconVariantComponent
  Location: IconVariantComponent
  Lock: IconVariantComponent
  Map: IconVariantComponent
  Medal2: IconVariantComponent
  Medal3: IconVariantComponent
  Medal: IconVariantComponent
  Menu: IconVariantComponent
  Merchant: IconVariantComponent
  Message: IconVariantComponent
  Meter: IconVariantComponent
  MobileBanking: IconVariantComponent
  MoneyTime: IconVariantComponent
  MoneyTransfer: IconVariantComponent
  More: IconVariantComponent
  NewByronManageLimits: IconVariantComponent
  NewByronPhoneGeneral: IconVariantComponent
  NoCreditCheck: IconVariantComponent
  NoFees: IconVariantComponent
  Notification: IconVariantComponent
  OpeningTime: IconVariantComponent
  Order: IconVariantComponent
  PasswordHide: IconVariantComponent
  PasswordShow: IconVariantComponent
  Payid: IconVariantComponent
  Phone: IconVariantComponent
  Pie: IconVariantComponent
  Piggy: IconVariantComponent
  Printer: IconVariantComponent
  Profile: IconVariantComponent
  Refresh: IconVariantComponent
  Refund: IconVariantComponent
  Search: IconVariantComponent
  Send: IconVariantComponent
  Settings: IconVariantComponent
  Share2: IconVariantComponent
  Share: IconVariantComponent
  Shipping1: IconVariantComponent
  Shipping2: IconVariantComponent
  Shop: IconVariantComponent
  ShoppingCart: IconVariantComponent
  Star: IconVariantComponent
  StarHollow: IconVariantComponent
  Support: IconVariantComponent
  Thumbsup: IconVariantComponent
  Time: IconVariantComponent
  Trash: IconVariantComponent
  Verified: IconVariantComponent
  Warning: IconVariantComponent
  WarningAlt: IconVariantComponent
  Write: IconVariantComponent
}

export const Icon: IconComponent = (props) => {
  return <BaseIcon {...props} />
}

const Add: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.ADD} {...otherProps} />
}
const Afterpay: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.AFTERPAY} {...otherProps} />
}
const ArrowDown: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.ARROWDOWN} {...otherProps} />
}
const ArrowLeft: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.ARROWLEFT} {...otherProps} />
}
const ArrowRight: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.ARROWRIGHT} {...otherProps} />
}
const ArrowUp: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.ARROWUP} {...otherProps} />
}
const Attachment: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.ATTACHMENT} {...otherProps} />
}
const Bank: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.BANK} {...otherProps} />
}
const BankStatement: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.BANKSTATEMENT} {...otherProps} />
}
const Barcode: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.BARCODE} {...otherProps} />
}
const BasketUpdate: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.BASKETUPDATE} {...otherProps} />
}
const Box: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.BOX} {...otherProps} />
}
const BoxArrowDown: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.BOXARROWDOWN} {...otherProps} />
}
const Bpay: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.BPAY} {...otherProps} />
}
const Browser: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.BROWSER} {...otherProps} />
}
const Bulb: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.BULB} {...otherProps} />
}
const Calendar: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.CALENDAR} {...otherProps} />
}
const CalendarDate: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.CALENDARDATE} {...otherProps} />
}
const Camera: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.CAMERA} {...otherProps} />
}
const Car: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.CAR} {...otherProps} />
}
const Card: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.CARD} {...otherProps} />
}
const CardUpdate: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.CARDUPDATE} {...otherProps} />
}
const CaretDown: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.CARETDOWN} {...otherProps} />
}
const CaretLeft: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.CARETLEFT} {...otherProps} />
}
const CaretRight: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.CARETRIGHT} {...otherProps} />
}
const CaretUp: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.CARETUP} {...otherProps} />
}
const Chat: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.CHAT} {...otherProps} />
}
const Chatting: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.CHATTING} {...otherProps} />
}
const Check: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.CHECK} {...otherProps} />
}
const CheckIn: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.CHECKIN} {...otherProps} />
}
const CheckOut: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.CHECKOUT} {...otherProps} />
}
const Cheque: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.CHEQUE} {...otherProps} />
}
const Close: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.CLOSE} {...otherProps} />
}
const CloseCircle: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.CLOSECIRCLE} {...otherProps} />
}
const Coins: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.COINS} {...otherProps} />
}
const Copy: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.COPY} {...otherProps} />
}
const CurrencyExchange: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.CURRENCYEXCHANGE} {...otherProps} />
}
const Discount2: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.DISCOUNT2} {...otherProps} />
}
const Dollar: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.DOLLAR} {...otherProps} />
}
const Download: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.DOWNLOAD} {...otherProps} />
}
const DownloadAlt: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.DOWNLOADALT} {...otherProps} />
}
const Edit: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.EDIT} {...otherProps} />
}
const Email: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.EMAIL} {...otherProps} />
}
const Exit: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.EXIT} {...otherProps} />
}
const External: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.EXTERNAL} {...otherProps} />
}
const Filter: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.FILTER} {...otherProps} />
}
const Gift: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.GIFT} {...otherProps} />
}
const Globe: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.GLOBE} {...otherProps} />
}
const Grid: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.GRID} {...otherProps} />
}
const Guard: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.GUARD} {...otherProps} />
}
const Handout: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.HANDOUT} {...otherProps} />
}
const Heart: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.HEART} {...otherProps} />
}
const Heartbeat: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.HEARTBEAT} {...otherProps} />
}
const History: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.HISTORY} {...otherProps} />
}
const Home: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.HOME} {...otherProps} />
}
const Image: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.IMAGE} {...otherProps} />
}
const Info: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.INFO} {...otherProps} />
}
const Lightning: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.LIGHTNING} {...otherProps} />
}
const Link: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.LINK} {...otherProps} />
}
const Loan: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.LOAN} {...otherProps} />
}
const Location: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.LOCATION} {...otherProps} />
}
const Lock: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.LOCK} {...otherProps} />
}
const Map: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.MAP} {...otherProps} />
}
const Medal: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.MEDAL} {...otherProps} />
}
const Medal2: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.MEDAL2} {...otherProps} />
}
const Medal3: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.MEDAL3} {...otherProps} />
}
const Menu: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.MENU} {...otherProps} />
}
const Merchant: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.MERCHANT} {...otherProps} />
}
const Message: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.MESSAGE} {...otherProps} />
}
const Meter: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.METER} {...otherProps} />
}
const MobileBanking: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.MOBILEBANKING} {...otherProps} />
}
const MoneyTime: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.MONEYTIME} {...otherProps} />
}
const MoneyTransfer: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.MONEYTRANSFER} {...otherProps} />
}
const More: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.MORE} {...otherProps} />
}
const NewByronManageLimits: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.NEWBYRONMANAGELIMITS} {...otherProps} />
}
const NewByronPhoneGeneral: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.NEWBYRONPHONEGENERAL} {...otherProps} />
}
const NoCreditCheck: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.NOCREDITCHECK} {...otherProps} />
}
const NoFees: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.NOFEES} {...otherProps} />
}
const Notification: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.NOTIFICATION} {...otherProps} />
}
const OpeningTime: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.OPENINGTIME} {...otherProps} />
}
const Order: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.ORDER} {...otherProps} />
}
const PasswordHide: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.PASSWORDHIDE} {...otherProps} />
}
const PasswordShow: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.PASSWORDSHOW} {...otherProps} />
}
const Payid: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.PAYID} {...otherProps} />
}
const Phone: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.PHONE} {...otherProps} />
}
const Pie: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.PIE} {...otherProps} />
}
const Piggy: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.PIGGY} {...otherProps} />
}
const Printer: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.PRINTER} {...otherProps} />
}
const Profile: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.PROFILE} {...otherProps} />
}
const Refresh: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.REFRESH} {...otherProps} />
}
const Refund: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.REFUND} {...otherProps} />
}
const Search: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.SEARCH} {...otherProps} />
}
const Send: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.SEND} {...otherProps} />
}
const Settings: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.SETTINGS} {...otherProps} />
}
const Share: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.SHARE} {...otherProps} />
}
const Share2: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.SHARE2} {...otherProps} />
}
const Shipping1: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.SHIPPING1} {...otherProps} />
}
const Shipping2: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.SHIPPING2} {...otherProps} />
}
const Shop: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.SHOP} {...otherProps} />
}
const ShoppingCart: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.SHOPPINGCART} {...otherProps} />
}
const Star: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.STAR} {...otherProps} />
}
const StarHollow: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.STARHOLLOW} {...otherProps} />
}
const Support: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.SUPPORT} {...otherProps} />
}
const Thumbsup: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.THUMBSUP} {...otherProps} />
}
const Time: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.TIME} {...otherProps} />
}
const Trash: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.TRASH} {...otherProps} />
}
const Verified: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.VERIFIED} {...otherProps} />
}
const Warning: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.WARNING} {...otherProps} />
}
const WarningAlt: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.WARNINGALT} {...otherProps} />
}
const Write: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <Icon name={BRONTE_ICONS_NAMES.WRITE} {...otherProps} />
}

Icon.Add = Add
Icon.Afterpay = Afterpay
Icon.ArrowDown = ArrowDown
Icon.ArrowLeft = ArrowLeft
Icon.ArrowRight = ArrowRight
Icon.ArrowUp = ArrowUp
Icon.Attachment = Attachment
Icon.Bank = Bank
Icon.BankStatement = BankStatement
Icon.Barcode = Barcode
Icon.BasketUpdate = BasketUpdate
Icon.Box = Box
Icon.BoxArrowDown = BoxArrowDown
Icon.Bpay = Bpay
Icon.Browser = Browser
Icon.Bulb = Bulb
Icon.Calendar = Calendar
Icon.CalendarDate = CalendarDate
Icon.Camera = Camera
Icon.Car = Car
Icon.Card = Card
Icon.CardUpdate = CardUpdate
Icon.CaretDown = CaretDown
Icon.CaretLeft = CaretLeft
Icon.CaretRight = CaretRight
Icon.CaretUp = CaretUp
Icon.Chat = Chat
Icon.Chatting = Chatting
Icon.Check = Check
Icon.CheckIn = CheckIn
Icon.CheckOut = CheckOut
Icon.Cheque = Cheque
Icon.Close = Close
Icon.CloseCircle = CloseCircle
Icon.Coins = Coins
Icon.Copy = Copy
Icon.CurrencyExchange = CurrencyExchange
Icon.Discount2 = Discount2
Icon.Dollar = Dollar
Icon.Download = Download
Icon.DownloadAlt = DownloadAlt
Icon.Edit = Edit
Icon.Email = Email
Icon.Exit = Exit
Icon.External = External
Icon.Filter = Filter
Icon.Gift = Gift
Icon.Globe = Globe
Icon.Grid = Grid
Icon.Guard = Guard
Icon.Handout = Handout
Icon.Heart = Heart
Icon.Heartbeat = Heartbeat
Icon.History = History
Icon.Home = Home
Icon.Image = Image
Icon.Info = Info
Icon.Lightning = Lightning
Icon.Link = Link
Icon.Loan = Loan
Icon.Location = Location
Icon.Lock = Lock
Icon.Map = Map
Icon.Medal = Medal
Icon.Medal2 = Medal2
Icon.Medal3 = Medal3
Icon.Menu = Menu
Icon.Merchant = Merchant
Icon.Message = Message
Icon.Meter = Meter
Icon.MobileBanking = MobileBanking
Icon.MoneyTime = MoneyTime
Icon.MoneyTransfer = MoneyTransfer
Icon.More = More
Icon.NewByronManageLimits = NewByronManageLimits
Icon.NewByronPhoneGeneral = NewByronPhoneGeneral
Icon.NoCreditCheck = NoCreditCheck
Icon.NoFees = NoFees
Icon.Notification = Notification
Icon.OpeningTime = OpeningTime
Icon.Order = Order
Icon.PasswordHide = PasswordHide
Icon.PasswordShow = PasswordShow
Icon.Payid = Payid
Icon.Phone = Phone
Icon.Pie = Pie
Icon.Piggy = Piggy
Icon.Printer = Printer
Icon.Profile = Profile
Icon.Refresh = Refresh
Icon.Refund = Refund
Icon.Search = Search
Icon.Send = Send
Icon.Settings = Settings
Icon.Share = Share
Icon.Share2 = Share2
Icon.Shipping1 = Shipping1
Icon.Shipping2 = Shipping2
Icon.Shop = Shop
Icon.ShoppingCart = ShoppingCart
Icon.Star = Star
Icon.StarHollow = StarHollow
Icon.Support = Support
Icon.Thumbsup = Thumbsup
Icon.Time = Time
Icon.Trash = Trash
Icon.Verified = Verified
Icon.Warning = Warning
Icon.WarningAlt = WarningAlt
Icon.Write = Write
